import { http } from '../http';

export const getIsInContactsListService = async (contactIds) => {
  try {
    const response = await http.get('/contact/list', {
      params: {
        contactIds,
      },
      baseURL: process.env.CONTACTS_SLS_BASE_URL,
    });
    return response?.data?.length;
  } catch (e) {
    console.error('something went wrong', e);
    return false;
  }
};

export default {
  getIsInContactsListService,
};
